import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import econsentReducer from 'login-reducers/econsentReducer';
import globalReducer from 'login-reducers/globalReducer';
import layoutReducer from 'login-reducers/layoutReducer';
import onboardingReducer from 'login-reducers/onboardingReducer';
import privacyPolicyReducer from 'login-reducers/privacyPolicyReducer';
import termsReducer from 'login-reducers/termsReducer';

export default combineReducers({
  global: globalReducer,
  layout: layoutReducer,
  form: formReducer,
  onboarding: onboardingReducer,
  terms: termsReducer,
  econsent: econsentReducer,
  privacyPolicy: privacyPolicyReducer,
});
